import React from "react";
import { Link } from 'react-router-dom';
import '../style/StartAproject.css';





export default function StartAProject() {
    return(
        <>
        
            <section className="section-7">
                <div className="imgch text-center">
                <img src={require("../img/checkim.png")} alt="Error" />
                </div>
                <h2 className="mt-5">Your order will be processed shortly and you will be notified.</h2>
                <p className="text-secondary lead">Stay with us</p>
                <Link className="lin btn btn-6" to="/">Return to home page</Link>

            </section>
        </>
    )
}